

import Select                                   from 'react-select';
import { Dialog, DialogBackdrop, DialogPanel }  from '@headlessui/react';
import { useEffect, useState, useRef }          from 'react';
import { useForm, Controller }                  from "react-hook-form";

import loadingGif                               from '../../assets/gif-loading-yellow.gif';        
import uploadIcon                               from '../../assets/InputFileForm/upload-icon.svg';  

import '../../styles/LoadingTable.css'

function JustificationFileForm({
        isOpen,
        selectValues,
        onClose,
        files,
        setFiles,
        handleChangePlanningRange,
        onSubmit,
        isloading,
        errorMessage
    }) {

    const { 

        control, 
        register,
        handleSubmit,
        setValue

    } = useForm();
    
    //#region Drag and Drop

    const inputRef                      = useRef(null);
    const [dragActive, setDragActive]   = useState(false);

    const handleDrag = (e) => {

        e.preventDefault();
        e.stopPropagation();

        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {

        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);

        const file = e.dataTransfer.files?.[0];
        
        if (!file) return;

        if (!file.name.toLowerCase().endsWith(".csv")) {
            
            alert("Apenas arquivos .csv são permitidos!");
            return;
        }

        setFiles([file]);
    };

    const handleChange = (e) => {
        
        const file = e.target.files?.[0];

        if (!file) return;

        if (!file.name.toLowerCase().endsWith(".csv")) {
            alert("Apenas arquivos .csv são permitidos!");
            return;
        }

        setFiles([file]);

    };

    //#endregion

    //#region File Utils
        
        const formatFileSize = (bytes) => {
            if      (bytes < 1024)          return bytes + ' bytes';
            else if (bytes < 1048576)       return (bytes / 1024).toFixed(2) + ' KB';
            else if (bytes < 1073741824)    return (bytes / 1048576).toFixed(2) + ' MB';
            else                            return (bytes / 1073741824).toFixed(2) + ' GB';
        };

        const removeFile = (fileName) => {
            setFiles(files.filter(file => file.name !== fileName));
        };

        useEffect(() => {

            if (files.length > 0) {
                setValue("excelFile", files[0]);
            } else {
                setValue("excelFile", null);
            }

        }, [files, setValue]);

    //#endregion

    return(

        <Dialog 
            open={isOpen} 
            onClose={onClose} 
            className="relative z-[100]"
        >

            <DialogBackdrop 
                transition 
                className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div 
                className="fixed inset-0 z-10 w-screen overflow-y-auto"
            >
                <div 
                    className=" flex min-h-full items-end justify-center p-1 text-center sm:items-center sm:p-0"
                >
                    <DialogPanel 
                        transition 
                        className="w-[808px] relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >   
                        <div className="app-container">
                            
                            <header className="bg-azul-profundo-m flex justify-between items-center pl-4 pr-1 py-3">
                                
                                <h2 className="text-white text-[1rem] leading-7 font-semibold">Inserir Base de Comparações</h2>
                                <button onClick={onClose} className="text-[1.2rem] text-white hover:text-gray-200 pr-2">×</button>
                         
                            </header>

                            <section className="px-4 pb-4 pt-1 sm:pb-4 flex flex-col gap-[10px]">

                                <div className="mt-3 flex flex-col w-full">
                                    
                                    <span className="text-sm font-semibold">
                                        Selecione o horizonte de planejamento:
                                    </span>
                                    
                                        <Controller
                                            control={control}
                                            name="fileType"
                                            isSerchable="false"
                                            rules={{ required: false }}
                                            render={({ field }) => (

                                                <Select
                                                    {...field}
                                                    options={selectValues}
                                                    classNamePrefix="select"
                                                    isSearchable={false}
                                                    defaultValue={selectValues[0]}
                                                    onChange={(option) => handleChangePlanningRange(option)}    
                                                    
                                                />

                                            )}
                                        />
                                </div>

                                <div className="mt-3 flex flex-col w-full">  
                                    <div className="flex flex-col mb-4">
                                                                        
                                        <span className=" text-sm font-semibold mb-[3px]">
                                            Importar o arquivo:
                                        </span>

                                        <div className="relative" onDragEnter={handleDrag}>
                                            
                                            {/* Drop zone */}
                                            <input
                                                ref={inputRef}
                                                type="file"
                                                className="hidden"
                                                accept=".csv"
                                                onChange={handleChange}
                                                {...register("excelFile", { required: false })}
                                            />
                                            
                                            <div 
                                                className={`h-32 border-[1.5px] ${dragActive ? 'border-azul-profundo-m bg-azul-ceu-c' : 'border-dashed border-cinza-chumbo-c'} rounded-[3px] flex flex-col items-center justify-center cursor-pointer`}
                                                onDragEnter={handleDrag}
                                                onDragLeave={handleDrag}
                                                onDragOver={handleDrag}
                                                onDrop={handleDrop}
                                            >
                                                
                                                <div className="text-gray-500 mb-2">
                                                    <img src={uploadIcon} height="25px" width="25px"/>
                                                </div>
                                                
                                                <div className="text-center">
                                                    <span className="text-azul-profundo-m">Arraste e solte o arquivo aqui.</span>
                                                    <p className="text-gray-500 text-sm mt-1">Apenas arquivos .csv (máx. 500KB)</p>
                                                </div>
                                            </div>
                                                      
                                            {files.length > 0 && (
                                                
                                                <div className="mt-2 "> 
                                                    <div className="p-2 bg-gray-100 rounded-[3px] flex justify-between items-center">
                                                        
                                                        <div>
                                                            <p className="font-medium">
                                                                {files[0].name}
                                                            </p>
                                                            <p className="text-sm text-gray-500">
                                                                {formatFileSize(files[0].size)}
                                                            </p>
                                                        </div>
                                                        
                                                        <button 
                                                            type="button"//lixeira
                                                            className="text-red-500 hover:text-red-700"
                                                            onClick={() => removeFile(files[0].name)}
                                                        >
                                                        
                                                            <svg className="w-5 h-5" 
                                                                fill="none" 
                                                                stroke="currentColor" 
                                                                viewBox="0 0 24 24" 
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path 
                                                                    strokeLinecap="round" 
                                                                    strokeLinejoin="round" 
                                                                    strokeWidth="2" 
                                                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                >
                                                                </path>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                    {/* #endregion */}

                                </div>
                                
                                { isloading &&(
                                    <div className="flex flex-row border-[1px] border-cinza-chumbo rounded-[6px] p-3 items-left gap-2 ">
                                        <img src={loadingGif} className="w-6 h-6"/>
                                        <span>Enviado a base...</span>
                                    </div>
                                )}

                                { errorMessage &&(
                                    <div className="text-[12px] flex flex-row text-red-600 border border-red-600 bg-red-100/10 rounded-[6px] p-3 items-left gap-2 ">
                                        <span>{errorMessage}</span>
                                    </div>
                                )}


                                

                            </section>
        
                            <footer className="w-full bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                
                                <button 
                                    type="submit" 
                                    onClick={handleSubmit(onSubmit)} 
                                    className="btn btn-azul-prof sm:ml-3 w-[50%] text-[1.125rem]"
                                >
                                    Salvar
                                </button>

                                <button 
                                    type="button"   
                                    onClick={onClose} 
                                    className="btn btn-cinza w-[50%] text-[1.125rem]"
                                >
                                    Cancelar
                                </button>
                                
                            </footer>

                        </div>
                        
                    </DialogPanel>
                </div>
            </div>

        </Dialog>
    )
}


export default JustificationFileForm;